import { useEffect, useState } from 'preact/hooks';

import { emitter } from '../event_emitter/initialized';

const EVENT_NAME = 'external_trs_changed';

export const listenExternalTrs = (handler: (trs: string) => void) => {
  emitter.addListener(EVENT_NAME, handler);
  return () => emitter.removeListener(EVENT_NAME, handler);
};

export const setExternalTrs = (trs: string) => {
  emitter.emitEvent(EVENT_NAME, [trs]);
};

export const useExternalTrs = (existingTrs: unknown) => {
  const [trs, setTrs] = useState<undefined | string>(undefined);

  useEffect(() => {
    if (!existingTrs) {
      listenExternalTrs(setTrs);
    }
  }, []);

  return trs;
};
